import { colors } from "../colors"

export const Link = {
  baseStyle: {
    fontFamily: "Sofia Pro",
    color: colors.text.icon,
    "&:hover": { textDecoration: "none" },
  },
}
